module.exports = __webpack_public_path__ + "static/iStock-1181815669-c7f9c5a518932c628320fc54a52bd644.mp4";